import { render } from "./CloseOrderModal.vue?vue&type=template&id=a038f498&scoped=true"
import script from "./CloseOrderModal.vue?vue&type=script&lang=js"
export * from "./CloseOrderModal.vue?vue&type=script&lang=js"

import "./CloseOrderModal.vue?vue&type=style&index=0&id=a038f498&scoped=true&lang=less"

import exportComponent from "C:\\REPOS\\pos-web-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a038f498"]])

export default __exports__